"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgQuestionCircleSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm.058 17.05c-.51-.03-.973.328-1.064.843l-.01.059-.014.118a1.021 1.021 0 002.026.235l.01-.059.014-.118c.03-.51-.328-.974-.844-1.064zM12 5.05c-2.134 0-3.83 1.673-3.83 3.83a.766.766 0 001.532 0c0-1.307 1.005-2.299 2.298-2.299 1.262 0 2.298 1.074 2.298 2.408 0 .85-.26 1.39-.982 1.974l-.264.225c-.17.152-.328.31-.474.473a5.27 5.27 0 00-1.185 2.12c-.135.488-.175.91-.16 1.233l.002.03.018.134a.766.766 0 001.51-.235l-.001-.13c.01-.58.258-1.353.955-2.128.165-.184.352-.361.562-.532l.196-.165c.94-.831 1.355-1.765 1.355-3 0-2.167-1.71-3.938-3.83-3.938z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgQuestionCircleSolid;
exports.default = _default;